export default function (instance) {
  return {
    signUp (personalDetail) {
      return instance
        .post('/api/user/signup', personalDetail)
        .then(response => response.data)
    },

    loginUdi ({ accessToken }) {
      return instance
        .post('/api/user/signin-udi', { accessToken })
        .then(response => response.data)
    },

    fetchProfile () {
      return instance
        .get('/api/user/details')
        .then(response => response.data)
    },

    adyenpastduepayment (paymentProvider, sbeCompliance, invoiceId, orderNumber, paymentMethodCode) {
      return instance
        .post(`/api/payment/PastDuePaymentSessionRequest?paymentProvider=${paymentProvider}&sbeCompliance=${sbeCompliance}&invoiceId=${invoiceId}&orderNumber=${orderNumber}&paymentMethodCode=${paymentMethodCode}`)
        
        .then(response => response.data)
    },

    updateAddressTask(postCode,stateName,callbackOnUpdate) { 
      return instance
        .get('/api/user/Validateaddress?stateName=' + stateName.name +'&postCode=' + postCode)     
        .then(response => {callbackOnUpdate(response.data, postCode, stateName)})  
   }, 

    updateProfile ({ accessToken }) {
      return instance
        .post('/api/user/profile-udi', {
          accessToken
        })
        .then(response => response.data)
    },

    updatePersonalDetail ({ firstName, lastName, phoneNumber, selectedNewsletter, sbeCompliance }, bundleName, bundles) {
      return instance
        .post('/api/user/details', {
          firstName,
          lastName,
          phoneNumber,
          selectedNewsletter,
          bundleName,
          bundles,
          sbeCompliance
        })
        .then(response => response.data)
    },

    updateOptIn ({ accessToken, optIn }) {
      return instance
        .post('/api/user/opt-in', {
          accessToken,
          optIn
        })
        .then(response => response.data)
    },

    updateAddress (addresses,allianzCodeApplied) {
      return instance
        .post('/api/user/addresses', {
          addresses,
          allianzCodeApplied
        })
        .then(function (response) { 
          return{
           data:response.data,
           status:response.status,  
         }  
        
     })
    },

    changePaymentMethod (paymentMethodCode, cancelPaymentUrl, sbeCompliance) {
      return instance
        .post('/api/user/paymentprofile', {
          paymentMethodCode,
          cancelPaymentUrl,
          sbeCompliance
        })
        .then(response => response.data)
    },

    adyenchangeprofile (paymentProvider, paymentMethodCode, sbeCompliance, orderNumber) {
      return instance
        .post(`/api/payment/ChangePaymentSessionRequest?paymentProvider=${paymentProvider}&paymentMethodCode=${paymentMethodCode}&sbeCompliance=${sbeCompliance}&orderNumber=${orderNumber}`)
        
        .then(response => response.data)
    },

    getMyPaymentMethod () {
      return instance
        .get('/api/user/paymentprofile')
        .then(response => response.data)
    },

    payInFullWithChangePaymentMethod (subscriptionNumber, subscriptionRatePlanId, promotionCode, paymentMethodCode, cancelPaymentUrl, sbeCompliance) {
      return instance
        .post('/api/users/current/payment-profile-with-pay-in-full', {
          subscriptionNumber,
          subscriptionRatePlanId,
          promotionCode,
          paymentMethodCode,
          cancelPaymentUrl,
          sbeCompliance
        })
        .then(response => response.data)
    },

    adyenpayinfull (paymentProvider, paymentMethodCode, sbeCompliance, orderNumber, amount ) {
      return instance
        .post(`/api/payment/PayinfullPaymentSessionRequest?paymentProvider=${paymentProvider}&paymentMethodCode=${paymentMethodCode}&sbeCompliance=${sbeCompliance}&orderNumber=${orderNumber}&amount=${amount}`)
        
        .then(response => response.data)
    },

    payNowWithChangePaymentMethod (paymentMethodCode, invoiceId, cancelPaymentUrl, sbeCompliance) {
      return instance
        .post('/api/users/current/payment-profile-with-immediate-payment', {
          paymentMethodCode,
          invoiceId,
          cancelPaymentUrl,
          sbeCompliance
        })
        .then(response => response.data)
    },

    mailValidation (email) {
      return instance
        .post('/api/user/mail-validation', {
          email
        })
        .then(response => response.data)
    },

    getPaymentActivity () {
      return instance
        .get('/api/user/payment-activity')
        .then(response => response.data)
        .catch(err => console.log(err))
    },

    currentLanguage (languageCode) {
      return instance
        .post('/api/users/current/language', {
          languageCode
        })
        .then(response => response.data)
    }
  }
}
